export default __webpack_public_path__ + "static/doradztwo-d260757f133cb67aeac5073fca6d80f0.webp";